function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DataplexParameterComponent from "@/apps/data-platform/modules/data_quality_dataplex/components/DataplexParameterComponent";
export default {
  components: {
    DataplexParameterComponent: DataplexParameterComponent
  },
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    },
    key_component: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      pagination_execution_detail: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      }
    };
  },
  computed: {
    header_details: function header_details() {
      return [{
        text: this.traductor('data_quality.dataplex.quality.execution_detail.column'),
        value: 'rule.column'
      }, {
        text: this.traductor('data_quality.dataplex.quality.execution_detail.rule'),
        value: 'rule_inca.name'
      }, {
        text: this.traductor('data_quality.dataplex.quality.execution_detail.state'),
        value: 'passed'
      }, {
        text: this.traductor('data_quality.dataplex.quality.execution_detail.validation'),
        value: 'expectation'
      }, {
        text: this.traductor('data_quality.dataplex.quality.execution_detail.dimension'),
        value: 'dimension'
      }, {
        text: this.traductor('data_quality.dataplex.quality.execution_detail.parameters'),
        value: 'parameters'
      }, {
        text: this.traductor('data_quality.dataplex.quality.execution_detail.row_errors'),
        value: 'rowCount'
      }, {
        text: this.traductor('data_quality.dataplex.quality.execution_detail.threashold'),
        value: 'threshold'
      }];
    }
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    objectToHtmlList: function objectToHtmlList(obj) {
      function createList(item) {
        var html = '<ul>';
        for (var key in item) {
          if (item.hasOwnProperty(key)) {
            html += "<li><strong>".concat(key, ":</strong> ");
            if (_typeof(item[key]) === 'object' && !Array.isArray(item[key])) {
              // Recursively create list for nested objects
              html += createList(item[key]);
            } else if (Array.isArray(item[key])) {
              // Create list for array elements
              html += '<ul>';
              item[key].forEach(function (element, index) {
                html += "<li>[".concat(index, "] ").concat(_typeof(element) === 'object' ? createList(element) : element, "</li>");
              });
              html += '</ul>';
            } else {
              // Add primitive values
              html += item[key];
            }
            html += '</li>';
          }
        }
        html += '</ul>';
        return html;
      }
      return createList(obj);
    }
  }
};